// Recovered compiled webpack factory 33452. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { e: () => n });
  function n(t, { style: e, vars: i }, n, s) {
    let r,
      o = t.style;
    for (r in e) o[r] = e[r];
    for (r in (s?.applyProjectionStyles(o, n), i)) o.setProperty(r, i[r]);
  }
}
